
export enum StockFlagType {
  "1" = `#icon-bao`,
  "3" = `#icon-shen`,
  "4" = `#icon-jinyin`,
  "11" = "#icon-denglv",
  "12" = "#icon-denglan",
  "13" = "#icon-dengrongzi",
  "21" = "#icon-denghuang",
  "22" = "#icon-dengzi",
  "31" = "#icon-dengbai",
  "32" = "#icon-denghong",
  "91" = "#icon-denghei",
}



// WEBPACK FOOTER //
// ./src/components/OYFilter/components/OYFlag/enum.ts